/* Pet Portrait Parlour: small interactions for the ppp-* sections.
   Content is visible by default; reveal animations only switch on once this script is running. */
(function () {
  if (window.__pppInit) return;
  window.__pppInit = true;

  var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduceMotion = !!(motionQuery && motionQuery.matches);

  /* ---------- Reveal on scroll ---------- */
  var revealObserver = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.ppp-reveal:not(.is-in)');
    if (reduceMotion || (window.matchMedia && window.matchMedia('(max-width: 749px), (pointer: coarse)').matches) || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); revealObserver.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    var vh = window.innerHeight || 800;
    els.forEach(function (el) {
      // anything already on screen is shown straight away, so there is no flash
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) { el.classList.add('is-in'); return; }
      revealObserver.observe(el);
    });
    document.documentElement.classList.add('ppp-js');
  }

  /* ---------- Before / after slider ---------- */
  function initCompare(root) {
    (root || document).querySelectorAll('.ppp-compare').forEach(function (box) {
      var input = box.querySelector('input[type="range"]');
      if (!input || input.__ppp) return;
      input.__ppp = true;
      var set = function () { box.style.setProperty('--pos', input.value + '%'); };
      input.addEventListener('input', set);
      set();
    });
  }

  /* ---------- Reveal video: sound, play/pause, reduced motion, pause off screen ---------- */
  function safePlay(video) {
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }
  function setPlayButton(btn, playing) {
    if (!btn) return;
    btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    btn.querySelector('[data-icon-pause]').hidden = !playing;
    btn.querySelector('[data-icon-play]').hidden = playing;
  }
  function initVideo(root) {
    (root || document).querySelectorAll('.ppp-reveal-vid__media').forEach(function (media) {
      var video = media.querySelector('video');
      if (!video || video.__ppp) return;
      video.__ppp = true;
      var soundBtn = media.querySelector('[data-ppp-sound]');
      var playBtn = media.querySelector('[data-ppp-play]');
      var userPaused = reduceMotion;   // with reduced motion, nothing plays until the visitor presses play
      var onScreen = false;
      video.removeAttribute('autoplay');
      var maybePlay = function () { if (!userPaused && onScreen) safePlay(video); };
      setPlayButton(playBtn, !video.paused);

      if (soundBtn) soundBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        if (!video.muted) { userPaused = false; safePlay(video); }
        soundBtn.setAttribute('aria-pressed', String(!video.muted));
        soundBtn.querySelector('[data-icon-muted]').hidden = !video.muted;
        soundBtn.querySelector('[data-icon-sound]').hidden = video.muted;
      });
      if (playBtn) playBtn.addEventListener('click', function () {
        if (video.paused) { userPaused = false; safePlay(video); } else { userPaused = true; video.pause(); }
      });
      video.addEventListener('play', function () { setPlayButton(playBtn, true); });
      video.addEventListener('pause', function () { setPlayButton(playBtn, false); });
      if (motionQuery && motionQuery.addEventListener) motionQuery.addEventListener('change', function (e) {
        if (e.matches) { userPaused = true; video.pause(); }
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            onScreen = e.isIntersecting;
            if (!onScreen) { if (!video.paused) video.pause(); } else { maybePlay(); }
          });
        }, { threshold: 0.15 }).observe(video);
      } else {
        onScreen = true; maybePlay();
      }
    });
  }

  /* ---------- Format preview: draws the chosen style as the chosen format, to scale ---------- */
  var FORMATS = [
    { test: /digital/i, kind: 'digital', w: 150, h: 300, label: 'Digital download: a high-resolution file, emailed within 24 hours' },
    { test: /framed.*white/i, kind: 'framed', colour: 'white', w: 250, h: 337, label: 'A4 framed in white: your full A4 portrait (21 × 29.7 cm) in a classic wooden frame, about 25 × 33.7 cm outside. No mount' },
    { test: /framed.*(oak|natural)/i, kind: 'framed', colour: 'oak', w: 250, h: 337, label: 'A4 framed in oak-effect: your full A4 portrait (21 × 29.7 cm) in a classic wooden frame, about 25 × 33.7 cm outside. No mount' },
    { test: /framed.*black/i, kind: 'framed', colour: 'black', w: 250, h: 337, label: 'A4 framed in black: your full A4 portrait (21 × 29.7 cm) in a classic wooden frame, about 25 × 33.7 cm outside. No mount' },
    { test: /canvas.*(12|16|30)/i, kind: 'canvas', w: 305, h: 406, label: 'Canvas 12 × 16 in (about 30 × 40 cm), 3.8 cm deep. The picture’s edges are mirrored onto the sides' },
    { test: /canvas.*(8|10|20)/i, kind: 'canvas', w: 203, h: 254, label: 'Canvas 8 × 10 in (about 20 × 25 cm), 3.8 cm deep. The picture’s edges are mirrored onto the sides' },
    { test: /\ba3\b/i, kind: 'print', w: 297, h: 420, label: 'A3 art print, 29.7 × 42 cm, edge to edge' },
    { test: /\ba4\b.*print|^a4 print/i, kind: 'print', w: 210, h: 297, label: 'A4 art print, 21 × 29.7 cm, edge to edge' }
  ];

  function checkedValue(scope, optionName) {
    if (!optionName) return null;
    var want = optionName.toLowerCase();
    var inputs = scope.querySelectorAll('fieldset.variant-option input:checked');
    for (var i = 0; i < inputs.length; i++) {
      if ((inputs[i].dataset.optionName || '').toLowerCase() === want) return inputs[i].value;
    }
    var selects = scope.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      var s = selects[j];
      if ((s.dataset.optionName || s.name || '').toLowerCase().indexOf(want) !== -1) return s.value;
    }
    return null;
  }

  // Canvas mirror wrap: the side strip shows the front's right-hand 38 mm, reversed and foreshortened,
  // using the same "cover" crop as the front so the two meet cleanly at the corner.
  var imgSizes = {};
  function alignCanvasSide(box, spec, src) {
    var side = box.querySelector('[data-ppp-fp-side]');
    if (spec.kind !== 'canvas' || !src) { side.style.backgroundSize = ''; side.style.backgroundPosition = ''; return; }
    var apply = function (iw, ih) {
      var stage = box.querySelector('.ppp-fp__stage');
      var padding = box.classList.contains('ppp-fp--gallery') ? 64 : 44;
      var rawMM = getComputedStyle(stage).getPropertyValue('--mm').trim();
      var mm = /^[0-9.]+px$/.test(rawMM) ? parseFloat(rawMM) : (parseFloat(getComputedStyle(stage).height) - padding) / 420;
      var W = spec.w * mm, H = spec.h * mm, s = 38 * mm, k = 0.55;
      var scale = Math.max(W / iw, H / ih), dw = iw * scale, dh = ih * scale;
      var ox = (W - dw) * 0.5, oy = (H - dh) * 0.25;   // matches background-position: 50% 25%
      side.style.backgroundSize = (dw * k) + 'px ' + dh + 'px';
      side.style.backgroundPosition = ((ox - W + s) * k) + 'px ' + oy + 'px';
    };
    if (imgSizes[src]) { apply(imgSizes[src][0], imgSizes[src][1]); return; }
    var im = new Image();
    im.onload = function () { imgSizes[src] = [im.naturalWidth, im.naturalHeight]; apply(im.naturalWidth, im.naturalHeight); };
    im.src = src;
  }

  window.PPPFormatPreview = { formats: FORMATS, align: alignCanvasSide };

  function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }

  // The main gallery and the preview beside the options share one selected artwork.
  // Keep the original gallery available; changing an option returns to its format mockup.
  function syncGalleryPreview(box, spec, src, selection) {
    var scope = box.closest('.shopify-section');
    var gallery = scope && scope.querySelector('media-gallery');
    if (!gallery || !gallery.querySelector('slideshow-component')) return;
    var shell = gallery.querySelector('[data-ppp-gallery-preview]');
    if (!shell) {
      shell = document.createElement('div');
      shell.className = 'ppp ppp-gallery-preview';
      shell.setAttribute('data-ppp-gallery-preview', '');
      var controls = document.createElement('div');
      controls.className = 'ppp-gallery-preview__controls';
      controls.setAttribute('role', 'group');
      controls.setAttribute('aria-label', 'Product image view');
      ['Format preview', 'Artwork gallery'].forEach(function (label, index) {
        var button = document.createElement('button');
        button.type = 'button'; button.textContent = label;
        button.dataset.pppView = index ? 'artwork' : 'format';
        button.addEventListener('click', function () { setGalleryView(gallery, button.dataset.pppView); });
        controls.appendChild(button);
      });
      shell.appendChild(controls);
      var preview = document.createElement('div');
      preview.className = 'ppp-fp ppp-fp--gallery is-ready';
      shell.appendChild(preview);
      gallery.prepend(shell);
    }
    var panel = shell.querySelector('.ppp-fp--gallery');
    var key = box.__pppKey;
    if (panel.__pppKey !== key) {
      panel.replaceChildren();
      ['.ppp-fp__stage', '.ppp-fp__caption', '.ppp-fp__note'].forEach(function (selector) {
        var clone = box.querySelector(selector).cloneNode(true);
        // Only the preview beside the controls announces changes to screen readers.
        clone.removeAttribute('aria-live');
        panel.appendChild(clone);
      });
      panel.__pppKey = key;
    }
    alignCanvasSide(panel, spec, src);
    if (gallery.__pppSelection !== selection) {
      gallery.__pppSelection = selection;
      setGalleryView(gallery, spec.kind === 'digital' && !box.dataset.personalizedImage ? 'artwork' : 'format');
    }
  }

  function setGalleryView(gallery, view) {
    gallery.dataset.pppView = view;
    var shell = gallery.querySelector('[data-ppp-gallery-preview]');
    shell.querySelector('.ppp-fp--gallery').hidden = view !== 'format';
    shell.querySelectorAll('button[data-ppp-view]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.pppView === view));
    });
  }

  function updateFormatPreview(box) {
    var scope = box.closest('.shopify-section') || document;
    var images = {};
    try { images = JSON.parse(box.querySelector('[data-ppp-fp-images]').textContent); } catch (e) {}
    var format = checkedValue(scope, box.dataset.formatName) || box.dataset.formatInitial || '';
    var style = checkedValue(scope, box.dataset.styleName) || box.dataset.styleInitial || '';
    var spec = null;
    for (var i = 0; i < FORMATS.length; i++) { if (FORMATS[i].test.test(format)) { spec = FORMATS[i]; break; } }
    if (!spec) { box.hidden = true; return; }   // unknown format: show nothing rather than guess
    var own = images[style];
    var src = box.dataset.personalizedImage || own || images.__fallback;
    var stage = box.querySelector('.ppp-fp__stage');
    var key = spec.label + '|' + src + '|' + (box.dataset.personalizedNote || '') + '|' + getComputedStyle(stage).getPropertyValue('--mm');
    var selection = format + '|' + style + '|' + (box.dataset.personalizedImage || '');
    if (box.__pppKey === key) { syncGalleryPreview(box, spec, src, selection); return; }   // nothing changed: leave the live caption alone
    box.__pppKey = key;
    box.hidden = false;
    var obj = box.querySelector('[data-ppp-fp-obj]');
    obj.className = 'ppp-fp__obj ppp-fp__obj--' + spec.kind + (spec.colour ? ' ppp-fp__obj--' + spec.colour : '');
    obj.style.setProperty('--w', spec.w);
    obj.style.setProperty('--h', spec.h);
    if (src) {
      var bg = "url('" + src + "')";
      box.querySelector('[data-ppp-fp-art]').style.backgroundImage = bg;
      box.querySelector('[data-ppp-fp-side]').style.backgroundImage = bg;
    }
    alignCanvasSide(box, spec, src);
    setText(box.querySelector('[data-ppp-fp-caption]'), spec.label);
    var sample = own ? 'Example using this style’s sample' : 'Example using a sample portrait';
    setText(box.querySelector('[data-ppp-fp-note]'), box.dataset.personalizedImage ? box.dataset.personalizedNote : spec.kind === 'digital'
      ? sample + '. Your portrait will show your pet.'
      : sample + ', shown to scale. Your portrait will show your pet.');
    box.classList.add('is-ready');   // the preview stays hidden until it shows the right format
    syncGalleryPreview(box, spec, src, selection);
  }

  function initFormatPreview(root) {
    (root || document).querySelectorAll('[data-ppp-format-preview]').forEach(updateFormatPreview);
  }

  var fpTimer = null;
  function refreshFormatPreview() {
    clearTimeout(fpTimer);
    fpTimer = setTimeout(function () { initFormatPreview(); }, 40);
  }

  // Option changes; Horizon may re-render the product section, so re-query each time
  ['change', 'variant:update', 'variant:selected', 'ppp:preview-update'].forEach(function (type) {
    document.addEventListener(type, refreshFormatPreview);
  });
  // The phone/desktop scale differs: redraw (and re-align the canvas side) when the layout width changes
  window.addEventListener('resize', refreshFormatPreview);


  /* ---------- Mix & Match: tap designs in the gallery, then fill the order form's style dropdowns ---------- */
  var ORDINALS = [/^(first|1st)\b/i, /^(second|2nd)\b/i, /^(third|3rd)\b/i, /^(fourth|4th)\b/i, /^(fifth|5th)\b/i, /^(sixth|6th)\b/i];
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  // Easify's "First style / Second style / Third style" fields, in order
  function styleFields() {
    var roots = document.querySelectorAll('.easify-product-options .po-field-root');
    var found = [];
    ORDINALS.forEach(function (re, i) {
      for (var j = 0; j < roots.length; j++) {
        var lab = roots[j].querySelector('label span') || roots[j].querySelector('label');
        var t = lab ? lab.textContent.trim() : '';
        if (re.test(t) && /style|design/i.test(t) && roots[j].querySelector('button[aria-haspopup="listbox"]')) { found[i] = roots[j]; break; }
      }
    });
    return found;
  }

  function fieldValue(root) {
    var b = root.querySelector('button[aria-haspopup="listbox"]');
    var ph = b && b.querySelector('.po-select-placeholder');
    return ph ? '' : (b ? b.textContent.trim() : '');
  }

  function chooseIn(root, value) {
    var btn = root.querySelector('button[aria-haspopup="listbox"]');
    if (!btn) return Promise.resolve(false);
    if (fieldValue(root) === value) return Promise.resolve(true);
    btn.click();
    return wait(250).then(function () {
      var items = document.querySelectorAll('li.po-select-listItem');
      var hit = null;
      for (var i = 0; i < items.length; i++) {
        var t = items[i].textContent.trim();
        if (t === value || t.indexOf(value + ' ') === 0 || t.indexOf(value + '\n') === 0) { hit = items[i]; break; }
      }
      if (!hit) { btn.click(); return false; }
      hit.click();
      return wait(150).then(function () { return true; });
    });
  }

  function initPicker(root) {
    (root || document).querySelectorAll('[data-ppp-picker]').forEach(function (box) {
      if (box.__ppp) return;
      box.__ppp = true;
      var max = parseInt(box.getAttribute('data-ppp-picker'), 10) || 3;
      var key = 'ppp-picks:' + location.pathname;
      var picks = [];
      var applied = false;
      try { picks = JSON.parse(sessionStorage.getItem(key) || '[]').slice(0, max); } catch (e) { picks = []; }
      var tray = box.querySelector('[data-ppp-tray]');
      var list = box.querySelector('[data-ppp-chosen]');
      var title = box.querySelector('[data-ppp-tray-title]');
      var note = box.querySelector('[data-ppp-tray-note]');
      var useBtn = box.querySelector('[data-ppp-use]');

      function say(msg) { note.textContent = msg || ''; note.hidden = !msg; }
      function save() { try { sessionStorage.setItem(key, JSON.stringify(picks)); } catch (e) {} }

      function render() {
        box.querySelectorAll('.ppp-dg__pick').forEach(function (b) {
          var n = picks.indexOf(b.getAttribute('data-design'));
          b.setAttribute('aria-pressed', String(n !== -1));
          b.classList.toggle('is-picked', n !== -1);
          b.querySelector('.ppp-dg__num').textContent = n === -1 ? '' : String(n + 1);
        });
        tray.hidden = picks.length === 0;
        title.textContent = picks.length < max
          ? 'Your designs: ' + picks.length + ' of ' + max + ' picked'
          : 'Your ' + max + ' designs';
        list.innerHTML = '';
        picks.forEach(function (name, i) {
          var li = document.createElement('li');
          var rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'ppp-dg__remove';
          rm.setAttribute('aria-label', 'Remove ' + name);
          rm.textContent = '×';
          rm.addEventListener('click', function () { picks.splice(i, 1); applied = false; save(); render(); say(''); });
          li.appendChild(document.createTextNode((i + 1) + '. ' + name + ' '));
          li.appendChild(rm);
          list.appendChild(li);
        });
        useBtn.disabled = picks.length === 0;
      }

      box.addEventListener('click', function (e) {
        var b = e.target.closest('.ppp-dg__pick');
        if (!b) return;
        var name = b.getAttribute('data-design');
        var n = picks.indexOf(name);
        if (n !== -1) { picks.splice(n, 1); }
        else if (picks.length >= max) { say('You have picked ' + max + '. Tap one of them to swap it out.'); return; }
        else { picks.push(name); }
        applied = false;
        save(); render(); say('');
      });

      function apply(quiet) {
        var fields = styleFields();
        if (!fields.length) {
          if (!quiet) say('The order form below has no style choices yet. Your picks: ' + picks.join(', ') + '.');
          return Promise.resolve(false);
        }
        var chain = Promise.resolve(true);
        var missing = [];
        picks.forEach(function (name, i) {
          chain = chain.then(function () {
            if (!fields[i]) { missing.push(name); return; }
            return chooseIn(fields[i], name).then(function (ok) { if (!ok) missing.push(name); });
          });
        });
        return chain.then(function () {
          applied = true;
          if (!quiet) say(missing.length ? 'Not found in the order form: ' + missing.join(', ') + '. Please choose these there.' : 'Added to the order form below.');
          return true;
        });
      }

      useBtn.addEventListener('click', function () {
        apply(false).then(function () {
          var target = document.getElementById('mix-buy') || document.querySelector('.easify-product-options');
          if (target) target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
      });

      // Changing the format can redraw the order form: put the picks back if they were cleared
      var refillTimer = null;
      function refill() {
        if (!applied || !picks.length) return;
        clearTimeout(refillTimer);
        refillTimer = setTimeout(function () {
          var fields = styleFields();
          if (fields.length && fields.some(function (f, i) { return f && picks[i] && fieldValue(f) !== picks[i]; })) apply(true);
        }, 900);
      }
      ['change', 'variant:update', 'variant:selected', 'ppp:preview-update'].forEach(function (t) {
        document.addEventListener(t, function (e) { if (!box.contains(e.target)) refill(); });
      });

      render();
    });
  }

  function init(root) { initReveal(root); initCompare(root); initVideo(root); initFormatPreview(root); initPicker(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  // Theme editor: re-run when a section is added or changed
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // Horizon swaps product markup after a variant change. One observer on a stable ancestor also covers
  // sections that are replaced or added later; it only does work while a preview is on the page.
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      if (!document.querySelector('[data-ppp-format-preview]')) return;
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t.closest && !t.closest('[data-ppp-format-preview], [data-ppp-gallery-preview]')) { refreshFormatPreview(); return; }
      }
    }).observe(document.querySelector('main') || document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['checked', 'data-current-checked'] });
  }
})();

/* Sticky add-to-cart bar (Horizon): every portrait needs a photo and choices in the order form, so the bar's button
   takes the shopper to the form instead of adding from the bar. Horizon's own handler plays the "added" animation
   even when the form is incomplete and nothing was added. Runs in the capture phase on window, before Horizon's. */
(function () {
  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('sticky-add-to-cart [ref="addToCartButton"]');
    if (!b) return;
    var form = document.querySelector('.easify-product-options');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var target = document.getElementById('mix-buy') || form;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }, true);
})();
